import { TCountryId, TCurrency } from '@/src/components/sarComponent';

export interface StoreCouponViewModel {
  discount: number;
  type: CouponRewardType | string;
  subType: CouponRewardSubType | string;
}

export interface IStore {
  id: number;
  name?: string;
  arabicName: string;
  englishName: string;
  store: Store;
  distance: number;
  isOpen: boolean;
  isExpress: boolean;
  isNewStore?: boolean;
  acceptsBuyNowPayLater: boolean;
  orderTypes: (OrderType | string)[];
  countryId?: number;
  currency?: string;
  deliveryFees?: number;
  pikDeepLink?: string;
  discountOfferPercentage?: number;
  coupon?: StoreCouponViewModel | null;
  products?: any[];
}

interface Industry {
  id: number;
  arabicName: string;
  englishName: string;
}

export interface IStoresIndustryGroup {
  groupArabicName: string;
  groupEnglishName: string;
  industries: Industry[];
}

export enum OrderType {
  Now = 1,
  Scheduled = 2,
  Gift = 3,
  Pickup = 4, // not used
  Global = 5,
}

type TIndustries = {
  id: number;
  arabicName: string;
  englishName: string;
}[];
export interface Store {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  logoURL: string;
  logoUrl: string;
  arabicDescription: string;
  englishDescription: string;
  industries: TIndustries;
  arabicReturnPolicyTerms: string;
  englishReturnPolicyTerms: string;
}

export interface IBranch {
  BranchDetails: IBranchDetails;
  BranchIndustries: BranchIndustries[];
  IsFavoriteBranch: boolean;
}

export enum CouponRewardType {
  ProductsDiscount = 1,
  Cashback = 2,
  DeliveryDiscount = 3,
}

export enum CouponRewardSubType {
  FixedDiscount = 1,
  Percentage = 2,
  FixedDeliveryPrice = 3,
}

export interface IStoreCoupon {
  code: string;
  arabicName: string;
  englishName: string;
  endDate: string; // ISO 8601 date string
  stores: string[];
  minimumOrderAmount: number;
  type: CouponRewardType;
  subType: CouponRewardSubType;
  discount: number;
  maximumDiscountAmount: number;
}

export enum NavigationSectionType {
  Category = 1,
  Industry = 2,
}

export interface IStoreNavigationItem {
  id: number;
  integrationId: string;
  arabicName: string;
  englishName: string;
  arabicImagePath: string;
  englishImagePath: string;
}

export interface IStoreCategories {
  type: NavigationSectionType;
  items: IStoreNavigationItem[];
}

export interface IStoreSubNavigationSection {
  id: number;
  integrationId: string;
  arabicName: string;
  englishName: string;
  arabicImagePath: string;
  englishImagePath: string;
}

export interface ICloseBranch {
  branchId: string;
}

export interface BranchIndustries {
  id: number;
  arabicName: string;
  englishName: string;
  subIndustries: SubIndustry[] | null;
}

export interface SubIndustry {
  id: number;
  arabicName: string;
  englishName: string;
  subIndustries: SubIndustry[] | null;
}

export interface IBranchScheduleDays {
  day: number;
  dayString: string;
  arabicDayString: string;
  englishDayString: string;
  branchScheduleOpeningHours: {
    startHour: string;
    endHour: string;
  }[];
  isClosed: boolean;
}

export interface ISchedules {
  branchScheduleDays: IBranchScheduleDays[];
  scheduleType: number;
  scheduleTypeString: string;
  arabicScheduleTypeString: string;
  englishScheduleTypeString: string;
}

export interface IOrderTypes {
  type: number;
  typeString: string;
  arabicTypeString: string;
  englishTypeString: string;
}

export interface IBranchDetails {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  store: Store;
  orderTypes: IOrderTypes[];
  schedules: ISchedules[];
  availableBranches: AvailableBranches[];
  distance: number;
  deliveryFee: number;
  isOpen: boolean;
  isExpress: boolean;
  acceptsBuyNowPayLater: boolean;
  countryId: TCountryId;
  currencyCode: TCurrency;
  deliveryTime: string;
}

export interface AvailableBranches {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  distance: number;
  isOpen: boolean;
  isSelected: boolean;
}

export interface IStoreDepartment {
  id: number;
  arabicName: string;
  englishName: string;
  arabicImage: string | null;
  englishImage: string | null;
}

export interface IBranchEta {
  branchId: number;
  deliveryTime: string;
}
